import { convertValuesToFormData } from '../../components/react-hook-form/utils/convert-values';
import { EndPointService } from '../api-handlers/axios';

const ROUTE = 'god-speaks-bibles';

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const get = (id: string) => EndPointService.get(`/${ROUTE}/${id}`);
const update = (id: string, data: any) => {
    const formData =
        convertValuesToFormData({
            text: data?.text,
            verseNumber: data?.verseNumber,
            imageFile: data.imageFile[0],
        }) || {};

    return EndPointService.patch(`/${ROUTE}/${id}`, formData);
};
const create = (data: any) => {
    const formData =
        convertValuesToFormData({
            text: data?.text,
            verseNumber: data?.verseNumber,
            imageFile: data.imageFile[0],
        }) || {};

    return EndPointService.post(`/${ROUTE}/`, formData);
};
const remove = (id: string) => EndPointService.delete(`/${ROUTE}/${id}`);

export default {
    list,
    get,
    update,
    create,
    remove,
};
